import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Mail, Phone, MapPin } from 'lucide-react';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const Footer = () => {
  const [settings, setSettings] = useState({
    logo_url: '',
    tagline: "Australia's premier production 3D printing service",
    contact_email: 'hello@3dprintbureau.com.au',
    contact_phone: '+61 (0) 123 456 789',
    contact_address: 'Melbourne, Victoria, Australia'
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings/global`);
        if (response.data) {
          setSettings(prev => ({ ...prev, ...response.data }));
        }
      } catch (error) {
        console.error('Failed to fetch global settings:', error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <footer className="bg-[#0A0A0A] border-t border-white/10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              {settings.logo_url ? (
                <img src={settings.logo_url} alt="3D Print Bureau" className="h-20 md:h-24 lg:h-28 w-auto object-contain" />
              ) : (
                <div className="flex items-center gap-2">
                  <span className="text-[#CCFF00] font-bold text-2xl font-['Chivo']">3D</span>
                  <span className="text-white font-semibold">PRINT BUREAU</span>
                </div>
              )}
            </Link>
            <p className="text-white/50 text-sm leading-relaxed max-w-md">
              {settings.tagline}
            </p>
          </div>

          {/* Contact - Aligned Right */}
          <div className="md:text-right">
            <h4 className="text-white font-semibold mb-4 uppercase text-sm tracking-wide">Contact Us</h4>
            <div className="space-y-3">
              <a 
                href={`mailto:${settings.contact_email}`} 
                className="flex items-center gap-3 text-white/50 hover:text-[#CCFF00] transition-colors text-sm md:justify-end"
              >
                <span>{settings.contact_email}</span>
                <Mail className="w-4 h-4 text-[#CCFF00]" />
              </a>
              <a 
                href={`tel:${settings.contact_phone?.replace(/\s/g, '')}`} 
                className="flex items-center gap-3 text-white/50 hover:text-[#CCFF00] transition-colors text-sm md:justify-end"
              >
                <span>{settings.contact_phone}</span>
                <Phone className="w-4 h-4 text-[#CCFF00]" />
              </a>
              <div className="flex items-center gap-3 text-white/50 text-sm md:justify-end">
                <span>{settings.contact_address}</span>
                <MapPin className="w-4 h-4 text-[#CCFF00]" />
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-10 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/30 text-sm">
            © {new Date().getFullYear()} 3D Print Bureau. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm">
            <Link to="/track-order" className="text-white/30 hover:text-[#CCFF00] transition-colors">Track Order</Link>
            <a href="https://www.3dprintbureau.au" target="_blank" rel="noopener noreferrer" className="text-white/30 hover:text-[#CCFF00] transition-colors">Main Website</a>
            <span className="text-white/20 text-xs font-mono" title="Application Version">v1.8.0</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
